var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dynamicTime"},[_c('el-timeline',_vm._l((_vm.activities),function(activity,index){return _c('el-timeline-item',{key:index,attrs:{"icon":activity.icon,"type":activity.type,"color":activity.color,"size":activity.size}},[_vm._v(" "+_vm._s(activity.content + ' ' + activity.timestamp)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }